import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { fetchCategories } from '../lib/api';

const CategoriesContext = createContext({ categories: [], loaded: false, reload: async () => {} });

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(async () => {
    try {
      setCategories(await fetchCategories());
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <CategoriesContext.Provider value={{ categories, loaded, reload, setCategories }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export const useCategories = () => useContext(CategoriesContext);

// Full channel list in TV order: HOME, every category, ABOUT.
export function useChannels() {
  const { categories } = useCategories();
  return [
    { key: 'home', name: 'HOME', path: '/' },
    ...categories.map((c) => ({ ...c, path: `/${c.key}` })),
    { key: 'about', name: 'ABOUT', path: '/about', icon: 'about', hint: 'The person behind the signal' }
  ];
}
